"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _breakpoints = _interopRequireDefault(require("./breakpoints"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var Utils = {
  fontsAvailable: function fontsAvailable() {
    var result = [];
    var _document = document,
        fonts = _document.fonts;
    var it = fonts.entries();
    var arr = [];
    var done = false;

    while (!done) {
      var font = it.next();

      if (!font.done) {
        arr.push(font.value[0].family);
      } else {
        done = font.done;
      }
    } // converted to set then arr to filter repetitive values


    var allFontsAvailble = _toConsumableArray(new Set(arr));

    if (fonts) {
      result = allFontsAvailble;
    }

    return result;
  },
  isDesktop: function isDesktop() {
    var defaultWidth = 1000;
    var width = document.body.offsetWidth || defaultWidth;
    return width > _breakpoints.default.tablet;
  },
  isOnlywhiteSpaceOrEmpty: function isOnlywhiteSpaceOrEmpty(value) {
    return new RegExp("^\\s*$", "i").test(value);
  },
  stringToObject: function stringToObject(str) {
    var result = {};

    if (str && typeof str === 'string') {
      result = JSON.parse(str);
    }

    return result;
  },
  existSomeCheckboxInTrue: function existSomeCheckboxInTrue(checkboxes) {
    if (!checkboxes || !checkboxes.length) {
      return false;
    }

    var existTrue = false;
    var i = 0;

    while (!existTrue && i < checkboxes.length) {
      if (checkboxes[i].value) {
        existTrue = true;
      }

      i++;
    }

    return existTrue;
  }
};
var _default = Utils;
exports.default = _default;